import Inputmask from "inputmask";

const initPhoneMask = ( el ) => {
	if ( el.classList.contains( 'has-mask' ) )
	{
		return false;
	}

	Inputmask({"mask": "+7 (999) 999-99-99", showMaskOnHover: false}).mask(el);

	el.classList.add( 'has-mask' );
};

export default initPhoneMask;
